export const BUDGET_INFO_POPUP_DATA = {
  budgetSummaryInfoTitle:
    "With this configuration enabled, We will show budget summary and awards details on Manage and Reward page on Program site.",
  budgetCascadingInfoTitle: `
      When we have Budgets enabled, it enables positions and restrictions of events to be included or not in the budgets.On the Program side, 
      We get the option to define the budgets for the program and it's hierarchy.
       The awards are also works in accordance with the budgets defined.
       The Managers also gets to see below reports :-
        <ul>
          <li>Budget Spend</li>
          <li>Budget Allocation</li><li>Budget Change Log</li>
          <li>Budget Approval Summary</li>
          <li>Approval Hierarchy Summary</li>
        </ul>
      `,
  cascadingApproval: `When we have approvals enabled, it enables positions and defining of Approval flow on the admin side.
    On the Program side, The award isn't awarded immediately but use approval flow defined to give the award.
    The Managers also gets to see below reports :-
    <ul>
      <li>Approval Activity Summary</li>
      <li>Approval Hierarchy Summary</li>
    </ul>`,
  scheduleDate: `With this configuration enabled:-
    <ul>
      <li>Events Add/Edit will have option to enable Schedule date.</li>
      <li>The date selection will be visible dueing Award Creation.</li>
      <li>The Scheduled Date will be visible in pending approvals.</li>
     <li>The Scheduled Date will be visible in Approvals Report.</li>
    </ul>`,
};
